import React from 'react';

export const Alert = ({ children, variant = 'info', className = '', ...props }) => {
  const variants = {
    info: 'bg-blue-100 text-blue-800 border-blue-200',
    warning: 'bg-yellow-100 text-yellow-800 border-yellow-200',
    destructive: 'bg-red-100 text-red-800 border-red-200',
    success: 'bg-green-100 text-green-800 border-green-200',
  };

  return (
    <div className={`p-4 border rounded ${variants[variant]} ${className}`} {...props}>
      {children}
    </div>
  );
};

export const AlertDescription = ({ children, ...props }) => (
  <p className="text-sm" {...props}>
    {children}
  </p>
);
